import React from 'react'
import styled, { css } from 'styled-components'
import { YouTubeVid } from '.'

export const youTubeEmbedStyles = css`
	position: relative;
	padding-bottom: 56.25%;
	height: 0;
	background: ${props => props.theme.colors.midNeutral.val};

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
`

const YouTubeEmbedView = styled.div`
	${youTubeEmbedStyles}
`

export type YouTubeEmbedProps = {
	video: YouTubeVid
	width?: number
	height?: number
}
export const YouTubeEmbed = ({ video, width = 560, height = 315 }: YouTubeEmbedProps) => {
	const { youTubeVidId, title } = video

	return (
		<YouTubeEmbedView>
			<iframe
				width={width}
				height={height}
				src={`https://www.youtube.com/embed/${youTubeVidId}`}
				title={title}
				frameBorder='0'
				allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
				allowFullScreen
			></iframe>
		</YouTubeEmbedView>
	)
}
